var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.235,
    height: 20.235,
    viewBox: "3.373 3.373 20.235 20.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.36 3.373H5.62A2.255 2.255 0 0 0 3.374 5.62v15.738a2.255 2.255 0 0 0 2.248 2.249h15.738a2.255 2.255 0 0 0 2.249-2.249V5.621a2.255 2.255 0 0 0-2.249-2.248ZM10.117 19.11H7.869v-5.62h2.249v5.62Zm4.496 0h-2.248v-3.373h2.248v3.373Zm0-5.62h-2.248v-2.25h2.248v2.25Zm4.497 5.62h-2.248V7.869h2.248v11.242Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 366"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.6bdd704db1fd853ddc8c65d0fbdcb452.svg";
export { ForwardRef as ReactComponent };